// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetBookCurrencyQuote (params?: {}): Promise<Dict>;
    publicGetChartWeek (params?: {}): Promise<Dict>;
    publicGetChartWeekCurrencyQuote (params?: {}): Promise<Dict>;
    publicGetCurrency (params?: {}): Promise<List>;
    publicGetCurrencyAvailable (params?: {}): Promise<List>;
    publicGetCurrencyQuotes (params?: {}): Promise<List>;
    publicGetCurrencyCurrency (params?: {}): Promise<Dict>;
    publicGetPair (params?: {}): Promise<List>;
    publicGetPairAvailable (params?: {}): Promise<List>;
    publicGetTicker (params?: {}): Promise<List>;
    publicGetTickerBaseQuote (params?: {}): Promise<Dict>;
    publicGetTime (params?: {}): Promise<Dict>;
    publicGetTradeHistoryCurrencyQuote (params?: {}): Promise<List>;
    publicGetTradeFeeCurrencyQuote (params?: {}): Promise<Dict>;
    publicGetTradeFeeLevels (params?: {}): Promise<List>;
    publicGetTransactionBindings (params?: {}): Promise<List>;
    privateGetAuthAccount (params?: {}): Promise<List>;
    privateGetAuthAccountCurrencyCurrencyType (params?: {}): Promise<List>;
    privateGetAuthAccountFiltered (params?: {}): Promise<List>;
    privateGetAuthOrder (params?: {}): Promise<List>;
    privateGetAuthOrderActive (params?: {}): Promise<List>;
    privateGetAuthOrderGetOrderId (params?: {}): Promise<Dict>;
    privateGetAuthOrderPairCurrencyQuote (params?: {}): Promise<List>;
    privateGetAuthOrderPairCurrencyQuoteActive (params?: {}): Promise<List>;
    privateGetAuthStopOrder (params?: {}): Promise<List>;
    privateGetAuthStopOrderGetOrderId (params?: {}): Promise<Dict>;
    privateGetAuthStopOrderPairCurrencyQuote (params?: {}): Promise<List>;
    privateGetAuthStopOrderPairCurrencyQuoteActive (params?: {}): Promise<List>;
    privateGetAuthTrade (params?: {}): Promise<List>;
    privateGetAuthTradePairCurrencyQuote (params?: {}): Promise<List>;
    privateGetAuthTradeFeeCurrencyQuote (params?: {}): Promise<Dict>;
    privateGetAuthTransaction (params?: {}): Promise<Dict>;
    privateGetAuthTransactionBindings (params?: {}): Promise<Dict>;
    privateGetAuthTransactionBindingsCurrency (params?: {}): Promise<List>;
    privateGetAuthTransactionId (params?: {}): Promise<Dict>;
    privateGetAuthTransfer (params?: {}): Promise<Dict>;
    privatePostAuthOrderCancel (params?: {}): Promise<Dict>;
    privatePostAuthOrderCancelAll (params?: {}): Promise<Dict>;
    privatePostAuthOrderCancelAllCurrencyQuote (params?: {}): Promise<Dict>;
    privatePostAuthOrderCancelBulk (params?: {}): Promise<Dict>;
    privatePostAuthOrderPlace (params?: {}): Promise<Dict>;
    privatePostAuthOrderPlaceBulk (params?: {}): Promise<Dict>;
    privatePostAuthSpotDeposit (params?: {}): Promise<Dict>;
    privatePostAuthSpotWithdraw (params?: {}): Promise<Dict>;
    privatePostAuthStopOrderCancel (params?: {}): Promise<Dict>;
    privatePostAuthStopOrderCancelAll (params?: {}): Promise<Dict>;
    privatePostAuthStopOrderCancelAllCurrencyQuote (params?: {}): Promise<Dict>;
    privatePostAuthStopOrderPlace (params?: {}): Promise<Dict>;
    privatePostAuthTransactionDepositAddress (params?: {}): Promise<Dict>;
    privatePostAuthTransactionWithdraw (params?: {}): Promise<Dict>;
    privatePostAuthTransactionWithdrawCancel (params?: {}): Promise<Dict>;
    privatePostAuthTransactionWithdrawConfirm (params?: {}): Promise<Dict>;
    privatePostAuthTransactionWithdrawResendCode (params?: {}): Promise<Dict>;
    privatePostAuthTransferEmail (params?: {}): Promise<Dict>;
    privatePostAuthTransferId (params?: {}): Promise<Dict>;
    privatePostAuthTransferPhone (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
